export const modalInfoDescriptionStyle = {
	listTitle: {
		marginBottom: '8px',
	},

	listItem: {
		listStyle: 'inside',
		color: 'var(--info-500)',
		fontSize: '16px',
		marginLeft: '8px',

		'&:not(:last-child)': {
			marginBottom: '8px',
		},

		'&::marker': {
			content: 'none',
		},

		'& a': {
			display: 'list-item',

			'&::marker': {
				color: 'var(--info-500)',
			},
		},
	},

	linkHelp: {
		display: 'flex',
		marginBottom: '32px',
		alignItems: 'baseline',
		gap: '4px',
	},
};
